import Link from "next/link";
import { useTranslations } from "next-intl";
import { useState } from "react";

import myaccount from "~/components/common/myaccount.module.scss";
import useSubscriptions from "~/hooks/use-subscriptions";
import appRoutes from "~/utils/app-routes";

import Button from "../common/button";
import DataLevelBar from "./loyalty/data-level-bar";
import styles from "./loyalty-card.module.scss";
import QRCodeDialog from "./qrcode-dialog";

export default function LoyaltyCard() {
  const t = useTranslations();
  const { isUserSubscribedToLoyalty } = useSubscriptions();
  const [qrCodeDialogOpen, setQRCodeDialogOpen] = useState<boolean>(false);

  return (
    <>
      <div className={myaccount.myaccountCard}>
        <div className={myaccount.myaccountCardHeader}>
          <h2>{t("generic.myLoaltyTitle")}</h2>
          {isUserSubscribedToLoyalty ? (
            <Button lookAsLink onClick={() => setQRCodeDialogOpen(true)}>
              {t("generic.dashboard.showQRCode")}
            </Button>
          ) : null}
        </div>
        <div className={myaccount.myaccountCardContent}>
          {isUserSubscribedToLoyalty ? (
            <DataLevelBar />
          ) : (
            <p className={styles.noLoyalty}>
              {t.rich("generic.notEnrolledToLoyalty", {
                br: (chunks) => <br />,
                strong: (chunks) => <span className={styles.strong}>{chunks}</span>,
                myAccountLink: (chunks) => (
                  <Link className={styles.link} href={appRoutes.MYACCOUNT_SETTINGS}>
                    {chunks}
                  </Link>
                ),
              })}
            </p>
          )}
        </div>
      </div>
      <QRCodeDialog isOpen={qrCodeDialogOpen} onClose={() => setQRCodeDialogOpen(false)} />
    </>
  );
}
